import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import {DirectoryWithRouter} from './Directory';
import './index.sass';
import {HostPageMessenger} from './lib/HostPageMessenger';
import {inIframe} from './lib/inIframe';
// Static import order: config first (sets `window.iFrameResizer`), then the
// contentWindow script that reads it. Both must load eagerly with the main
// entry — the pre-migration CRA build used a synchronous `require()` for the
// contentWindow script; a `void import()` produces a separate chunk that races
// Prism's parent-side handshake and leaves the iframe blank.
import './lib/setupIframeResizerConfig';
import 'iframe-resizer/js/iframeResizer.contentWindow';

HostPageMessenger.on('ready', () => {
  ReactDOM.render((
    <BrowserRouter>
      <DirectoryWithRouter />
    </BrowserRouter>
  ), document.getElementById('root'));
});

if (!inIframe()) {
  if (window.origin.includes('localhost')) {
    HostPageMessenger.receive({method: 'ready'});
  } else {
    window.location.replace('https://zaius.com');
  }
}
